export const IMAGE_LINK = 'https://phpstack-922511-4090089.cloudwaysapps.com/storage'